import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: 'externalReferences' }),
  division: belongsTo('division', { inverse: 'externalReferences' }),
  label: belongsTo('label', { inverse: 'externalReferences' }),
  type: belongsTo('category', { inverse: null }),
});
